import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator.js'
import RequestSummaryCard from './RequestSummaryCard'
import Pagination from '../common/Pagination.jsx'
import productRequestTypes from '../../constants/productRequestTypes.js'

const SuggestedRequestsList = () => {
  const [currentPage, setCurrentPage] = useState(1)

  const queryParams = {
    page: currentPage,
    bidRequestType: productRequestTypes.finder.key,
  }

  const { data: requestsData } = useQuery({
    queryKey: QueryKeys.bidsList(queryParams),
    queryFn: () => handleGetRequest('/customer/bids/requests', queryParams),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  const requests = requestsData?.data || []
  const meta = requestsData?.meta

  return (
    <div>
      <div className="space-y-4 mb-4">
        {requests.length > 0 ? (
          requests.map((request) => <RequestSummaryCard key={request.id} request={request} />)
        ) : (
          <div className="text-center text-gray-500 py-10">
            <p>No product finder requests found.</p>
          </div>
        )}
        <Pagination paginationMeta={meta} onPageChange={setCurrentPage} />
      </div>
    </div>
  )
}

export default SuggestedRequestsList
